<template>
  <section>
    <validation-observer ref="form">
      <div v-for="(product, index) in collection" :key="index">
        <hr v-if="index > 0" />
        <div :id="`top-widget-${index}`" class="flex rows top-widget">
          <!-- photo -->
          <div class="item photo simulator">
            <div
              v-if="collection.length > 1"
              @click="deleteProduct(index)"
              class="btn delete-btn secondary"
            >
              <i class="far fa-trash-alt"></i>
            </div>
            <div
              v-show="false"
              class="simulator-position"
              :class="{ onlyName: product.pet_name && !product.pet_phone }"
            >
              <div class="name-simulator">
                {{ product.pet_name && product.pet_name.toUpperCase() }}
              </div>
              <div class="phone-simulator">
                {{ product.pet_phone && product.pet_phone.toUpperCase() }}
              </div>
            </div>
            <img class="simulator-photo" :src="decodeImage(product.color)" />
          </div>
          <!-- data -->
          <div class="item">
            <div class="flex columns">
              <!-- informations -->
              <div class="item">
                <div class="flex columns">
                  <div class="item">
                    <h2>
                      Coleira Personalizada
                      <span style="font-size: 37px; font-weight: 700">
                        petSAFE™
                      </span>
                    </h2>
                  </div>
                  <div class="item">
                    <h2 class="current-price">
                      <span
                        style="position:relative; color: #000; font-size: 24px; font-weight: 400"
                      >
                        <span
                          style=" position: absolute; border-bottom: 2px solid #000; width: 100%; top: 50%; left: -2px; "
                        ></span>
                        R$ {{ parseInt(product.price) * 2 }}
                      </span>
                      <span
                        style="color: #000; font-size: 24px; font-weight: 400"
                        >por</span
                      >
                      R$
                      {{ product.price }}
                    </h2>
                  </div>
                  <div class="item">
                    <h2>
                      ou apenas <b>12x</b> de
                      <b>
                        <span class="current-price-parcela"
                          >R$ {{ product.price_parcel }}</span
                        ></b
                      >
                    </h2>
                  </div>
                </div>
              </div>
              <hr />

              <!-- guia -->
              <div v-if="false" class="item">
                <div class="flex columns">
                  <div class="item">
                    <h3>
                      <span style="font-weight:400">Com guia: </span>
                      <span id="current-size">{{ product.guia }}</span>
                    </h3>
                  </div>
                  <div class="item" style="max-width: 400px">
                    <div class="flex wrap">
                      <div
                        v-for="(guia, indexGuia) in comGuia"
                        :key="indexGuia"
                      >
                        <div
                          :class="{
                            active: product.guia == guia,
                            'no-margin-left': indexGuia == 0,
                          }"
                          class="item btn w-size"
                          @click="changeGuiaProduct(index, guia)"
                        >
                          {{ guia }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- color -->
              <div class="item">
                <div class="flex columns">
                  <div class="item">
                    <h3>
                      <span style="font-weight:400">Modelo: </span
                      ><span id="current-color">{{
                        colorName(product.color)
                      }}</span>
                    </h3>
                  </div>
                  <div class="item">
                    <div class="flex wrap">
                      <div
                        v-for="(color, indexColor) in modelRender(product.guia)"
                        :key="indexColor"
                      >
                        <div
                          :class="{
                            active: product.color == color,
                            'color-3600811_1': color == '3600811_1',
                            'color-3600811_2': color == '3600811_2',
                            'color-3600811_3': color == '3600811_3',
                            'color-3600811_4': color == '3600811_4',
                            'color-3600811_5': color == '3600811_5',
                            'color-3600811_6': color == '3600811_6',
                            'color-3600811_7': color == '3600811_7',
                            'color-3600811_8': color == '3600811_8',
                            'color-3600811_9': color == '3600811_9',
                            'color-3600811_10': color == '3600811_10',
                            'color-3600811_11': color == '3600811_11',
                            'color-3600811_12': color == '3600811_12',
                            'color-3600811_13': color == '3600811_13',
                            'color-3600812_1': color == '3600812_1',
                            'color-3600812_2': color == '3600812_2',
                            'color-3600812_3': color == '3600812_3',
                            'color-3600812_4': color == '3600812_4',
                            'color-3600812_5': color == '3600812_5',
                            'color-3600812_6': color == '3600812_6',
                            'color-3600812_7': color == '3600812_7',
                            'color-3600812_8': color == '3600812_8',
                            'color-3600812_9': color == '3600812_9',
                            'color-3600812_10': color == '3600812_10',
                            'color-3600813_1': color == '3600813_1',
                            'color-3600813_2': color == '3600813_2',
                            'color-3600813_3': color == '3600813_3',
                            'color-3600813_4': color == '3600813_4',
                            'color-3600813_5': color == '3600813_5',
                            'color-3600813_6': color == '3600813_6',
                            'color-3600813_7': color == '3600813_7',
                          }"
                          class="item btn w-color"
                          style="margin-left: 5px;"
                          @click="product.color = color"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- size -->
              <div class="item">
                <div class="flex columns">
                  <div class="item">
                    <h3>
                      <span style="font-weight:400">Tamanho: </span>
                      <span id="current-size">{{ product.size }}</span>
                    </h3>
                  </div>
                  <div class="item" style="max-width: 400px">
                    <div class="flex wrap">
                      <div v-for="(size, indexSize) in sizes" :key="indexSize">
                        <div
                          :class="{
                            active: product.size == size,
                            'no-margin-left': indexSize == 0,
                          }"
                          class="item btn w-size"
                          @click="changeSizeProduct(index, size)"
                        >
                          {{ size }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- customization -->
              <div class="item">
                <div class="flex columns">
                  <validation-provider
                    :vid="`pet-name-${index}`"
                    name="Nome do PET"
                    rules="required|max:10"
                    v-slot="{ errors }"
                  >
                    <div class="group-input" :class="{ errors: errors[0] }">
                      <div class="item">
                        <h3>*Nome do PET:</h3>
                      </div>
                      <div class="item">
                        <input
                          v-model="product.pet_name"
                          name="custom-name-dog"
                          type="text"
                          maxlength="10"
                        />
                        <span class="erros-alert">{{ errors[0] }}</span>
                      </div>
                    </div>
                  </validation-provider>
                  <validation-provider
                    :vid="`pet-phone-${index}`"
                    name="Telefone"
                    rules="max:15|min:14"
                    v-slot="{ errors }"
                  >
                    <div class="group-input" :class="{ errors: errors[0] }">
                      <div class="item">
                        <h3>Telefone (Opcional):</h3>
                      </div>
                      <div class="item">
                        <input
                          class="phone_with_ddd"
                          v-model="product.pet_phone"
                          name="custom-phone-dog"
                          type="text"
                          v-mask="['(##) ####-####', '(##) #####-####']"
                          maxlength="15"
                          minlength="14"
                        />
                        <span class="erros-alert">{{ errors[0] }}</span>
                      </div>
                    </div>
                  </validation-provider>

                  <div v-if="false" class="item">
                    <a
                      :href="`#top-widget-${index}`"
                      style="text-decoration: none; color: #000;"
                    >
                      <div class="btn secondary">
                        Ver Coleira personalizada
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="action">
        <div v-if="collection && collection.length < 2">
          <p style="text-align:center">
            <b>ATENÇÃO</b>: Ao comprar <b>2 únidades</b> ou mais você ganha

            <span style="font-size:18px"><b>10% de desconto</b></span
            >!!!
          </p>
          <p style="text-align:center">
            <small>*Oferta valida apenas para compras feitas HOJE.</small>
          </p>
        </div>
        <div v-else>
          <p style="text-align:center">
            Parabéns, você <b>ganhou 10 % de desconto</b>. Oferta valida apenas
            para compras feitas HOJE!
          </p>
        </div>

        <div class="btn secondary" @click="addNewProduct()">
          + Adicionar mais uma
        </div>

        <!-- button -->
        <div
          @click="buyProducts()"
          id="buy-link"
          style="text-decoration: none;color: #000;"
        >
          <div class="btn buy button-animate">Comprar Agora</div>
        </div>
      </div>

      <div v-if="loader" id="background-loader">
        <div class="loader" id="loader"></div>
        <p>Carregando...</p>
      </div>
    </validation-observer>
  </section>
</template>

<script>
import { mask } from "vue-the-mask";

const mapping_price = {
  P: "105,90",
  M: "115,90",
  G: "125,90",
};

const mapping_price_guia = {
  P: "155,90",
  M: "165,90",
  G: "175,90",
};

const mapping_parcel_price = {
  P: "10,59",
  M: "11,59",
  G: "12,59",
};

const mapping_parcel_price_guia = {
  P: "15,59",
  M: "16,59",
  G: "17,59",
};

const mapping_product_to_model = {
  // product 1
  "3600811_1": "Azul Tribal + Guia",
  "3600811_2": "Verde Tribal + Guia",
  "3600811_3": "Verde Floral + Guia",
  "3600811_4": "Azul Floral + Guia",
  "3600811_5": "Psicodélico Verde + Guia",
  "3600811_6": "Psicodélico Roxo + Guia",
  "3600811_7": "Azul Detalhes + Guia",
  "3600811_8": "Azul Bolinha + Guia",
  "3600811_9": "Vermelho Bolinha + Guia",
  "3600811_10": "Preto Bolinha + Guia",
  "3600811_11": "Rosa Refletiva + Guia",
  "3600811_12": "Verde refletiva + Guia",
  "3600811_13": "Cinza Refletiva + Guia",

  // product 2
  "3600812_1": "Vermelho Bolinha",
  "3600812_2": "Preto Bolinha",
  "3600812_3": "Azul Bolinha",
  "3600812_4": "Laranja Neon",
  "3600812_5": "Vermelho Neon",
  "3600812_6": "Verde Neon",
  "3600812_7": "Azul Neon",
  "3600812_8": "Rosa Refletiva",
  "3600812_9": "Cinza Refletiva",
  "3600812_10": "Verde Refletiva",

  // product 3
  "3600813_1": "Azul Tribal",
  "3600813_2": "Verde Tribal",
  "3600813_3": "Verde Floral",
  "3600813_4": "Azul Floral",
  "3600813_5": "Psicodélico Verde",
  "3600813_6": "Psicodéico Roxo",
  "3600813_7": "Azul Detalhes",
};

const mapping_product = {
  // product 3600811 - Com guia
  "3600811_1 P": "JKAKY3VUW4",
  "3600811_1 M": "GIEUCI791L",
  "3600811_1 G": "EY8N8KM46R",

  "3600811_2 P": "7D9G0811NJ",
  "3600811_2 M": "C978Q1SHM8",
  "3600811_2 G": "BUZF9QPE02",

  "3600811_3 P": "B4MBM26YZB",
  "3600811_3 M": "3M3EDEG887",
  "3600811_3 G": "3G4LQ57MWF",

  "3600811_4 P": "SHBXK2B9B7",
  "3600811_4 M": "DPJCUEG1AV",
  "3600811_4 G": "H4QVQMR3CF",

  "3600811_5 P": "FUENF2PD5F",
  "3600811_5 M": "JDKI3GP4OM",
  "3600811_5 G": "EXBF6L6BRV",

  "3600811_6 P": "KQQ4KRVI9G",
  "3600811_6 M": "1RI0KVJXN5",
  "3600811_6 G": "8YVL3245JU",

  "3600811_7 P": "QCX0I4IVDO",
  "3600811_7 M": "M8HUX62OAJ",
  "3600811_7 G": "CS6WAEQA6P",

  "3600811_8 P": "E0A2IOKXBV",
  "3600811_8 M": "9JS9IEH7DA",
  "3600811_8 G": "6A76G2TIWM",

  "3600811_9 P": "K9R9JIO1HJ",
  "3600811_9 M": "K3UTT3ZCBW",
  "3600811_9 G": "QVXZ6295SG",

  "3600811_10 P": "IAX4LC8GH6",
  "3600811_10 M": "CKNUBJDV0J",
  "3600811_10 G": "N1KDXVN072",

  "3600811_11 P": "92998S2H1O",
  "3600811_11 M": "2AJILGRL78",
  "3600811_11 G": "44386RPR0Z",

  "3600811_12 P": "BJRB9LSVAN",
  "3600811_12 M": "2VGFQVRBDU",
  "3600811_12 G": "IGBE613DCV",

  "3600811_13 P": "ONGXXM75G8",
  "3600811_13 M": "3GFDAL16UF",
  "3600811_13 G": "IWIXPCUO65",

  // product 3600812
  "3600812_1 P": "6W52HXROL4",
  "3600812_1 M": "TPBSF9K3KS",
  "3600812_1 G": "KGZO1VMA8Z",

  "3600812_2 P": "LD7MSD46SX",
  "3600812_2 M": "SUGOUBKEWR",
  "3600812_2 G": "11C408EEOQ",

  "3600812_3 P": "AKI4LUPAWW",
  "3600812_3 M": "2TOZ2L9YIU",
  "3600812_3 G": "FUI1E8X0SE",

  "3600812_4 P": "CXBT1CDW32",
  "3600812_4 M": "I3SEO39E4E",
  "3600812_4 G": "48AAF4KBHQ",

  "3600812_5 P": "PPHMV5N34B",
  "3600812_5 M": "NOL2271LJF",
  "3600812_5 G": "RVKBARPE8G",

  "3600812_6 P": "NV33K0EQ3B",
  "3600812_6 M": "16CTIF6Z2Z",
  "3600812_6 G": "229ZRJ4FOL",

  "3600812_7 P": "1082IAA91L",
  "3600812_7 M": "6S58PW8ZBM",
  "3600812_7 G": "QBA7MUMIUU",

  "3600812_8 P": "IN39RBSJ5X",
  "3600812_8 M": "OLBOQW3JBC",
  "3600812_8 G": "THHA5ALTN1",

  "3600812_9 P": "KP1RUOUHTP",
  "3600812_9 M": "E4A8T2T5VT",
  "3600812_9 G": "A5HD9YJUO0",

  "3600812_10 P": "GZH4FE8QJB",
  "3600812_10 M": "SQTU8Y7DLO",
  "3600812_10 G": "M9JUOPLXFA",

  // product 3600813
  "3600813_1 P": "PGWTY6W1AZ",
  "3600813_1 M": "704D49BH9V",
  "3600813_1 G": "RIZQL38MPS",

  "3600813_2 P": "3AH1JFKP40",
  "3600813_2 M": "IV1AHGFW23",
  "3600813_2 G": "EQCCRPQ7VS",

  "3600813_3 P": "4W12N5MD11",
  "3600813_3 M": "LTIVTYAOQY",
  "3600813_3 G": "S8Z2G86OOS",

  "3600813_4 P": "BVW26AA8EC",
  "3600813_4 M": "1W776MHT6H",
  "3600813_4 G": "84E8TH6EUA",

  "3600813_5 P": "5Q7YM81ITW",
  "3600813_5 M": "AS02L2MLY2",
  "3600813_5 G": "Q5D3OY1IZE",

  "3600813_6 P": "381B0KJYJP",
  "3600813_6 M": "RRISSURJSD",
  "3600813_6 G": "M4T6QL2H1O",

  "3600813_7 P": "1IESX7NL6F",
  "3600813_7 M": "JDE94BHHIW",
  "3600813_7 G": "2OG8UDN9L0",
};

import Model3600811_1 from "@/assets/imgs/3600811_1.png";
import Model3600811_2 from "@/assets/imgs/3600811_2.png";
import Model3600811_3 from "@/assets/imgs/3600811_3.png";
import Model3600811_4 from "@/assets/imgs/3600811_4.png";
import Model3600811_5 from "@/assets/imgs/3600811_5.png";
import Model3600811_6 from "@/assets/imgs/3600811_6.png";
import Model3600811_7 from "@/assets/imgs/3600811_7.png";
import Model3600811_8 from "@/assets/imgs/3600811_8.png";
import Model3600811_9 from "@/assets/imgs/3600811_9.png";
import Model3600811_10 from "@/assets/imgs/3600811_10.png";
import Model3600811_11 from "@/assets/imgs/3600811_11.png";
import Model3600811_12 from "@/assets/imgs/3600811_12.png";
import Model3600811_13 from "@/assets/imgs/3600811_13.png";
import Model3600812_1 from "@/assets/imgs/3600812_1.png";
import Model3600812_2 from "@/assets/imgs/3600812_2.png";
import Model3600812_3 from "@/assets/imgs/3600812_3.png";
import Model3600812_4 from "@/assets/imgs/3600812_4.png";
import Model3600812_5 from "@/assets/imgs/3600812_5.png";
import Model3600812_6 from "@/assets/imgs/3600812_6.png";
import Model3600812_7 from "@/assets/imgs/3600812_7.png";
import Model3600812_8 from "@/assets/imgs/3600812_8.png";
import Model3600812_9 from "@/assets/imgs/3600812_9.png";
import Model3600812_10 from "@/assets/imgs/3600812_10.png";
import Model3600813_1 from "@/assets/imgs/3600813_1.png";
import Model3600813_2 from "@/assets/imgs/3600813_2.png";
import Model3600813_3 from "@/assets/imgs/3600813_3.png";
import Model3600813_4 from "@/assets/imgs/3600813_4.png";
import Model3600813_5 from "@/assets/imgs/3600813_5.png";
import Model3600813_6 from "@/assets/imgs/3600813_6.png";
import Model3600813_7 from "@/assets/imgs/3600813_7.png";

const imagesColor = {
  // product 1
  "3600811_1": Model3600811_1,
  "3600811_2": Model3600811_2,
  "3600811_3": Model3600811_3,
  "3600811_4": Model3600811_4,
  "3600811_5": Model3600811_5,
  "3600811_6": Model3600811_6,
  "3600811_7": Model3600811_7,
  "3600811_8": Model3600811_8,
  "3600811_9": Model3600811_9,
  "3600811_10": Model3600811_10,
  "3600811_11": Model3600811_11,
  "3600811_12": Model3600811_12,
  "3600811_13": Model3600811_13,

  // product 2
  "3600812_1": Model3600812_1,
  "3600812_2": Model3600812_2,
  "3600812_3": Model3600812_3,
  "3600812_4": Model3600812_4,
  "3600812_5": Model3600812_5,
  "3600812_6": Model3600812_6,
  "3600812_7": Model3600812_7,
  "3600812_8": Model3600812_8,
  "3600812_9": Model3600812_9,
  "3600812_10": Model3600812_10,

  // product 3
  "3600813_1": Model3600813_1,
  "3600813_2": Model3600813_2,
  "3600813_3": Model3600813_3,
  "3600813_4": Model3600813_4,
  "3600813_5": Model3600813_5,
  "3600813_6": Model3600813_6,
  "3600813_7": Model3600813_7,
};

const emptyProduct = {
  price: "105,90",
  price_parcel: "10,59",
  color: "3600812_1",
  size: "P",
  guia: "Não",
  pet_name: null,
  pet_phone: null,
};

export default {
  directives: { mask },
  name: "simulator",
  data() {
    return {
      loader: false,
      collection: [Object.assign({}, emptyProduct)],
      colors: Object.values(mapping_product_to_model),
      sizes: ["P", "M", "G"],
      comGuia: ["Não", "Sim"],
    };
  },
  computed: {},
  mounted() {},
  methods: {
    modelRender(guia) {
      let result = [];

      if (guia === "Sim") {
        let aux = Object.keys(mapping_product_to_model).filter((e) =>
          e.includes("3600811_")
        );

        aux.forEach((k) => {
          result.push(mapping_product_to_model[k]);
        });

        return aux;
      }

      let aux = Object.keys(mapping_product_to_model).filter(
        (e) => !e.includes("3600811_")
      );

      aux.forEach((k) => {
        result.push(mapping_product_to_model[k]);
      });

      return aux;
    },
    colorName(productId) {
      return mapping_product_to_model && mapping_product_to_model[productId];
    },
    addNewProduct() {
      this.collection.push(Object.assign({}, emptyProduct));
    },
    deleteProduct(index) {
      if (window.confirm("Você realmente quer remover o produto?")) {
        this.collection.splice(index, 1);
      }
    },
    buyProducts() {
      // save cookie product :)
      this.$refs.form.validate().then((success) => {
        if (!success) {
          alert("Você precisa preencher o Nome do PET");
          return;
        }

        let saveInfoProducts = [];

        this.collection.forEach((p) => {
          saveInfoProducts.push({
            color: p.color,
            size: p.size,
            pet_name: p.pet_name,
            pet_phone: p.pet_phone,
          });
        });

        this.setCookie("cp-coleira-csa", JSON.stringify(saveInfoProducts));

        // generate url
        let productsCode = [];
        this.collection.forEach((p) => {
          // get code checkout
          let key = `${p.color} ${p.size}`;
          let productCode = mapping_product[key];

          productsCode.push(`${productCode}:1`);
        });

        let url = `https://seguro.compresoagora.com/r/${productsCode.join(
          ","
        )}`;

        // 10% off in buy 2 products
        if (this.collection && this.collection.length > 1) {
          url += "?promocode=10%OFF";
        }

        this.loader = true;

        // redirect
        window.top.location.href = url;
      });
    },
    decodeImage(color) {
      return imagesColor[color];
    },
    changeSizeProduct(index, size) {
      this.collection[index].size = size;

      let guia = this.collection[index].guia;

      if (guia == "Sim") {
        this.collection[index].price = mapping_price_guia[size];
        this.collection[index].price_parcel = mapping_parcel_price_guia[size];
      } else {
        this.collection[index].price = mapping_price[size];
        this.collection[index].price_parcel = mapping_parcel_price[size];
      }
    },
    changeGuiaProduct(index, guia) {
      this.collection[index].guia = guia;

      let size = this.collection[index].size;

      if (guia == "Sim") {
        this.collection[index].price = mapping_price_guia[size];
        this.collection[index].price_parcel = mapping_parcel_price_guia[size];
      } else {
        this.collection[index].price = mapping_price[size];
        this.collection[index].price_parcel = mapping_parcel_price[size];
      }

      let optionsModel = this.modelRender(guia);
      this.collection[index].color = optionsModel[0];
    },
    setCookie(name, value) {
      const date = new Date();
      const days = 30;
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = "; expires=" + date.toGMTString();
      document.cookie =
        name + "=" + value + expires + "; path=/;domain=compresoagora.com";
      // document.cookie = name + "=" + value + expires + "; path=/";
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  background-color: #ffffff;
}
.flex {
  display: flex !important;
}
.wrap {
  flex-flow: wrap;
}
h2 {
  margin-top: 5px;
  margin-bottom: 5px;
}
.center {
  align-items: center;
  align-content: center;
  justify-content: center;
}
.columns {
  flex-direction: column;
}
.rows {
  flex-direction: row;
}
.item {
  flex: 1;
}
.photo > img {
  height: 700px;
}
.delete-btn {
  width: 10px;
  padding: 20px;
  position: absolute;
  z-index: 1001;
  right: 20px;
}
.btn {
  padding-top: 15px;
  padding-bottom: 15px;
  border-radius: 5px;
  background-color: #e6e5e5;
  border-bottom: 3px solid rgb(0, 0, 0);
  font-weight: 700;
  cursor: pointer;
}

.w-color {
  padding: 15px;
  border-radius: 5px;
  background-color: #c2c2c2;
  margin-left: 10px;
  border-bottom: 3px solid rgb(0, 0, 0);
  border-left: 1px solid rgb(0, 0, 0);
  font-weight: 700;
  cursor: pointer;
  &.active {
    border-bottom: 0px solid #333;
    border-left: 0px solid #333;
    filter: grayscale(30%);
  }
}
.secondary {
  margin-top: 15px;
  padding-top: 25px;
  padding-bottom: 25px;
  color: #0ab26e;
  background: #fff;
  border: 3px solid #0ab26e;
  text-align: center;
  box-shadow: 2px 3px 2px #8a8a8a;
  &:hover {
    background: #0ab26e;
    color: #fff;
  }
}

.w-size {
  padding: 15px;
  border-radius: 5px;
  background-color: #c2c2c2;
  margin-left: 10px;
  border-bottom: 3px solid rgb(0, 0, 0);
  border-left: 1px solid rgb(0, 0, 0);
  font-weight: 700;
  cursor: pointer;

  &.active {
    /* border: 1px solid #333; */
    border-bottom: 0px solid #333;
    border-left: 0px solid #333;
    background-color: #0ab26e;
  }
}

.buy {
  margin-top: 15px;
  margin-left: 0px;
  background-color: #c3c3c3;
  color: #fff;
  background-color: #0ab26e;
  text-align: center;
  font-size: 18px;
  font-weight: 800;
  padding-top: 25px;
  padding-bottom: 25px;
  border-radius: 5px;
  width: 100%;
}

hr {
  height: 0px;
  width: 100%;
  border-bottom: 1px solid rgba(51, 51, 51, 0.996);
}

.item input {
  width: 97%;
  height: 40px;
  font-size: 21px;
}
.simulator {
  position: relative;
  max-width: 700px;
}

.name-simulator {
  color: #fff;
  font-size: 32px;
  font-weight: 700;
  min-height: 55px;
  font-family: Muli, sans-serif;
  font-style: normal;
}
.phone-simulator {
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  font-family: Muli, sans-serif;
  font-style: normal;
}
.simulator-position {
  position: absolute;
  text-align: center;
  z-index: 10;
  top: -9%;
  left: -25%;
  width: 100%;
  height: 100%;
  padding-top: 50%;
  transform: rotate(19deg);
  &.onlyName {
    top: -8%;
    left: -26%;
    .name-simulator {
      font-size: 50px !important;
    }
  }
}
.top-widget {
  max-width: 1366px;
  margin: 0 auto;
  margin-bottom: 35px;
}

.color-3600811_1 {
  background: url("../../assets/imgs/color/3600811_1.jpg");
}

.color-3600811_2 {
  background: url("../../assets/imgs/color/3600811_2.jpg");
}

.color-3600811_3 {
  background: url("../../assets/imgs/color/3600811_3.jpg");
}

.color-3600811_4 {
  background: url("../../assets/imgs/color/3600811_4.jpg");
}

.color-3600811_5 {
  background: url("../../assets/imgs/color/3600811_5.jpg");
}

.color-3600811_6 {
  background: url("../../assets/imgs/color/3600811_6.jpg");
}

.color-3600811_7 {
  background: url("../../assets/imgs/color/3600811_7.jpg");
}

.color-3600811_8 {
  background: url("../../assets/imgs/color/3600811_8.jpg");
}

.color-3600811_9 {
  background: url("../../assets/imgs/color/3600811_9.jpg");
}

.color-3600811_10 {
  background: url("../../assets/imgs/color/3600811_10.jpg");
}

.color-3600811_11 {
  background: url("../../assets/imgs/color/3600811_11.jpg");
}

.color-3600811_12 {
  background: url("../../assets/imgs/color/3600811_12.jpg");
}

.color-3600811_13 {
  background: url("../../assets/imgs/color/3600811_13.jpg");
}

.color-3600812_1 {
  background: url("../../assets/imgs/color/3600812_1.jpg");
}

.color-3600812_2 {
  background: url("../../assets/imgs/color/3600812_2.jpg");
}

.color-3600812_3 {
  background: url("../../assets/imgs/color/3600812_3.jpg");
}

.color-3600812_4 {
  background: url("../../assets/imgs/color/3600812_4.jpg");
}

.color-3600812_5 {
  background: url("../../assets/imgs/color/3600812_5.jpg");
}

.color-3600812_6 {
  background: url("../../assets/imgs/color/3600812_6.jpg");
}

.color-3600812_7 {
  background: url("../../assets/imgs/color/3600812_7.jpg");
}

.color-3600812_8 {
  background: url("../../assets/imgs/color/3600812_8.jpg");
}

.color-3600812_9 {
  background: url("../../assets/imgs/color/3600812_9.jpg");
}

.color-3600812_10 {
  background: url("../../assets/imgs/color/3600812_10.jpg");
}

.color-3600813_1 {
  background: url("../../assets/imgs/color/3600813_1.jpg");
}

.color-3600813_2 {
  background: url("../../assets/imgs/color/3600813_2.jpg");
}

.color-3600813_3 {
  background: url("../../assets/imgs/color/3600813_3.jpg");
}

.color-3600813_4 {
  background: url("../../assets/imgs/color/3600813_4.jpg");
}

.color-3600813_5 {
  background: url("../../assets/imgs/color/3600813_5.jpg");
}

.color-3600813_6 {
  background: url("../../assets/imgs/color/3600813_6.jpg");
}

.color-3600813_7 {
  background: url("../../assets/imgs/color/3600813_7.jpg");
}

@keyframes zoominoutsinglefeatured {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.1, 1.1);
  }
  100% {
    transform: scale(1, 1);
  }
}
.button-animate {
  animation: zoominoutsinglefeatured 1s infinite;
}

.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

.current-price {
  color: #0ab26e;
  font-size: 36px;
}

#background-loader {
  position: fixed;
  display: flex !important;
  flex-direction: column;
  color: #fff;
  font-weight: 700;
  align-content: center;
  align-items: center;
  align-self: center;
  justify-content: center;
  z-index: 1000;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.hide-loader {
  display: none;
}

.group-input {
  &.errors input {
    border: 1px solid red;
    border-radius: 4px;
  }
  .erros-alert {
    display: inline-block;
    color: red;
    font-size: 11px;
  }
}

@media screen and (max-width: 1280px) {
  h2 {
    font-size: 18px;
  }
  .rows {
    flex-direction: column;
  }
  .photo > img {
    width: 100%;
    height: auto;
  }
  .item input {
    width: 95%;
  }
  .w-color {
    margin-left: 5px;
  }
  .w-size {
    margin-left: 5px;
  }
  .name-simulator {
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    min-height: 26px;
    font-family: Muli, sans-serif;
    font-style: normal;
  }
  .phone-simulator {
    color: #fff;
    font-size: 8px;
    font-family: Muli, sans-serif;
    font-style: normal;
  }
  .add {
    margin-top: 15px;
    padding-top: 25px;
    padding-bottom: 25px;
  }
  .btn {
    padding: 35px;
    margin-top: 5px;
    text-align: center;
  }
  .delete-btn {
    position: absolute;
    z-index: 999;
    width: auto;
    font-size: 20px;
    padding: 20px;
    position: absolute;
    right: 10px !important;
  }

  .secondary {
    margin-top: 15px;
  }
  .buy {
    width: 100%;
    padding-left: 0px;
    padding-right: 0px;
    padding-top: 35px;
    padding-bottom: 35px;
    margin-left: 0px;
    margin-top: 30px;
    text-align: center;
  }

  .simulator-position {
    height: 25%;
    top: -20px;
    left: -50px;

    &.onlyName {
      top: -20px;
      left: -50px;
      .name-simulator {
        font-size: 28px !important;
      }
    }
  }
}
</style>
